import AdIframeTs from "@Components/ad/adIframeTs";
import { setUrlFormat } from "@Lib/common";
import { IBuyCarMenuPolymer } from "@Types/buyCarMenu";
import React from "react";

export function formatNumberWithCommas(number) {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

// 分享模塊
export const ShareMenu: React.FC<{ inquiryCount: number; shareMenuCount: number; id?: string }> = ({
  inquiryCount,
  shareMenuCount,
  id,
}) => {
  return (
    <div
      id='ShareMenu'
      className='w-240 h-200 bg-no-repeat relative pt-16 mb-20 cursor-pointer'
      style={{ background: `url('https://photo.8891.com.tw/2024/07/31/1722387991060744.png')`, backgroundSize: "100%" }}
      onClick={() => {
        if (id) {
          window.open(`/buy-car/menu/share/form?id=${id}`, "_blank");
        } else {
          window.open(`/buycar/postMenu?type=1`, "_blank");
        }
      }}
    >
      <div className='text-center w-full text-20 mt-18 font-semibold'>分享菜單</div>
      <div className='text-center w-full mt-20 text-16'>
        已有<span className='text-[#FF4433]'>{formatNumberWithCommas(shareMenuCount)}</span>位車主分享
      </div>
      <div className='text-center w-full text-16 mt-4'>
        幫助<span className='text-[#FF4433]'>{formatNumberWithCommas(inquiryCount)}</span>位買家
      </div>
      <div
        className='text-14 text-[#279C70] w-130 h-30 rounded-4 font-semibold flex items-center justify-center mt-20 mx-auto'
        style={{ border: "1px solid #279C70" }}
      >
        立即分享
      </div>
    </div>
  );
};

// 征求模塊
export const SeekMenu: React.FC<{ seekMenuCount: number; source: string; id?: string }> = ({
  seekMenuCount,
  source,
  id,
}) => {
  return (
    <div
      id='SeekMenu'
      className='w-240 h-200 bg-no-repeat relative pt-16  mb-20'
      style={{ background: `url('https://photo.8891.com.tw/2024/07/31/1722392113152087.png')`, backgroundSize: "100%" }}
      onClick={() => {
        if (id) {
          window.open(`/buy-car/menu/seek/form?id=${id}source=${source}`, "_blank");
        } else {
          window.open(`/buycar/postMenu?type=2&source=${source}`, "_blank");
        }
      }}
    >
      <div className='text-center w-full text-20 mt-18 font-semibold'>徵求菜單</div>
      <div className='text-center w-full mt-20 text-16'>
        已有<span className='text-[#FF4433]'>{formatNumberWithCommas(seekMenuCount)}</span>位用戶發佈
      </div>
      <div className='text-center w-full text-16 mt-4'>最快2分鐘報價</div>

      <div
        className='text-14 text-[#3264FF] w-130 h-30 rounded-4 font-semibold flex items-center justify-center mt-20 mx-auto cursor-pointer'
        style={{ border: "1px solid #3264FF" }}
      >
        立即徵求
      </div>
    </div>
  );
};

export const MenuEntry: React.FC<{ shareMenuCount: any; inquiryCount: any; id?: string; source?: string }> = ({
  shareMenuCount,
  inquiryCount,
  id,
  source,
}) => {
  return (
    <div
      className='w-240 h-[438px] pt-16 px-10 flex-col justify-center mb-20 rounded-4 border-1 border-solid border-[#e8e8e8] relative'
      style={{ background: "linear-gradient(0deg,#ffffff 45%, #eff6ff)" }}
    >
      <img
        src='https://photo.8891.com.tw/2024/09/20/1726825144550690.png'
        className='w-70 h-52 absolute right-0 top-0'
      />
      <div className='text-20 font-semibold text-[#333] mb-20 text-center w-full'>購車菜單</div>
      <div className='text-16 text-[#333] font-normal text-center w-full leading-22'>
        已有<span className='text-[#FF4433]'>{formatNumberWithCommas(shareMenuCount)}</span>位車主分享
      </div>
      <div className='text-16 text-[#333] font-normal text-center w-full leading-22'>
        幫助<span className='text-[#FF4433]'>{formatNumberWithCommas(inquiryCount)}</span>位買家
      </div>

      <div className='mt-30 flex flex-col'>
        <div className='flex items-center'>
          <img src='https://photo.8891.com.tw/2024/09/20/1726825313680081.png' className='w-20 h-20' />
          <span className='text-16 font-medium text-[#333] mx-4'>徵求菜單</span>
          <span className=' rounded-2 h-18 flex items-center text-center px-4 bg-[#DEEBFF] text-[#64748B] text-12'>
            準車主
          </span>
        </div>
        <div className='pl-24 flex items-center mt-16 border-0 border-b-1 border-solid border-[#e8e8e8] pb-16'>
          <div className='text-12 text-[#999] flex-1 flex-wrap'>發佈您的購車需求<br />業代最快2分鐘報價！</div>
          <div
            className='bg-[#3264ff] text-[#fff] rounded-4 w-64 h-28 leading-28 text-14 text-center ml-14 cursor-pointer'
            id='seek-form-entry'
            onClick={() => {
              if (id) {
                window.open(`/buy-car/menu/seek/form?id=${id}&source=${source}`, "_blank");
              } else {
                window.open(`/buycar/postMenu?type=2&source=${source}`, "_blank");
              }
            }}
          >
            去徵求
          </div>
        </div>
      </div>
      <div className='mt-16 flex flex-col'>
        <div className='flex items-center'>
          <img src='https://photo.8891.com.tw/2024/09/25/1727251993494746.png' className='w-20 h-20' />
          <span className='text-16 font-medium text-[#333] mx-4'>分享詢價菜單</span>
          <span className=' rounded-2 h-18 flex items-center text-center px-4 bg-[#DEEBFF] text-[#64748B] text-12'>
            已詢價準車主
          </span>
        </div>
        <div className='pl-24 flex items-center mt-16 border-0 border-b-1 border-solid border-[#e8e8e8] pb-16'>
          <div className='text-12 text-[#999] flex-1 flex-wrap'>分享您詢價後的報價<br />更多網友幫您參謀！</div>
          <div
            className='bg-[#1DBF76] text-[#fff] rounded-4 w-64 h-28 leading-28 text-14 text-center ml-14 cursor-pointer'
            id='share-form-entry-2'
            onClick={() => {
              if (id) {
                window.open(`/buy-car/menu/share/form?id=${id}&subType=2`, "_blank");
              } else {
                window.open(`/buycar/postMenu?type=1&subType=2`, "_blank");
              }
            }}
          >
            去分享
          </div>
        </div>
      </div>
      <div className='mt-16 flex flex-col'>
        <div className='flex items-center'>
          <img src='https://photo.8891.com.tw/2024/09/25/1727251998026616.png' className='w-20 h-20' />
          <span className='text-16 font-medium text-[#333] mx-4'>分享購車菜單</span>
          <span className=' rounded-2 h-18 flex items-center text-center px-4 bg-[#DEEBFF] text-[#64748B] text-12'>
            已購車車主
          </span>
        </div>
        <div className='pl-22 flex items-center mt-16 border-0 pb-16'>
          <div className='text-12 text-[#999] flex-1 flex-wrap'>曬一曬您的購車菜單<br />幫助更多人！</div>
          <div
            className='bg-[#1DBF76] text-[#fff] rounded-4 w-64 h-28 leading-28 text-14 text-center ml-14 cursor-pointer'
            id='share-form-entry-1'
            onClick={() => {
              if (id) {
                window.open(`/buy-car/menu/share/form?id=${id}&subType=1`, "_blank");
              } else {
                window.open(`/buycar/postMenu?type=1&subType=1`, "_blank");
              }
            }}
          >
            去分享
          </div>
        </div>
      </div>
    </div>
  );
};

const AdItem: React.FC<any> = ({ data }) => {
  const { img, link } = data;

  return (
    <>
      {!!data.link && (
        <a href={link} target='_blank'>
          <img className='w-full mb-20 rounded-4' src={img} />
        </a>
      )}
    </>
  );
};

// 廣告
export const AdRight: React.FC<{ slot: string }> = ({ slot }) => {
  // 版位：新車-PC-菜單列表頁-右側橫幅
  // 代碼：newcar-pc-menu-right
  // 委刊項id：6762217427

  // 版位：新車-PC-菜單詳情頁-右側橫幅
  // 代碼：newcar-pc-menuDetails-right
  // 委刊項id：6762217919
  return (
    <AdIframeTs slot={slot} size={[["fluid"], ["fluid"]]} refresh={false} callBack={(_event) => {}}>
      <AdItem />
    </AdIframeTs>
  );
};

// 加入8891業代模塊
export const JoinMarket: React.FC<{ unfinishedUsers: number }> = ({ unfinishedUsers }) => {
  return (
    <div
      id='ShareMenu'
      className='w-240 h-200 bg-no-repeat relative pt-16  mb-20 cursor-pointer text-white'
      style={{ background: `url('https://photo.8891.com.tw/2024/07/31/1722393139683211.png')`, backgroundSize: "100%" }}
      onClick={() => {
        window.open(`/agent/investment`, "_blank");
      }}
    >
      <div className='text-center w-full text-20 mt-8 font-semibold'>加入8891業代！</div>
      <div className='text-center w-full text-20 mt-8 font-semibold'>獲客翻倍</div>
      <div className='text-center w-full mt-20 text-16' style={{ fontWeight: 300 }}>
        待服務的線索數<span className='text-[#FFEA01]'>{formatNumberWithCommas(unfinishedUsers)}</span>人
      </div>
      <div className='text-center w-full text-16 mt-4' style={{ fontWeight: 300 }}>
        最快當天成交!
      </div>

      <div className='text-14 text-[#3264FF] w-130 h-30 bg-white rounded-4 font-semibold flex items-center justify-center mt-20 mx-auto'>
        搶先獲客
      </div>
    </div>
  );
};

// 優質菜單排行
export const RankingList: React.FC<{ hotMenuKindRank: IBuyCarMenuPolymer["hotMenuKindRank"]; id?: string }> = ({
  hotMenuKindRank,
  id,
}) => {
  return (
    <>
      {hotMenuKindRank?.length > 0 && (
        <div
          id={"RankingList"}
          className='w-240 rounded-4  px-10 mb-20 bg-white pb-16'
          style={{ border: "1px solid #E8E8E8" }}
        >
          <div className='text-center w-full text-18 mt-12 font-semibold my-14 pt-4'>優質菜單排行</div>
          <div className='w-full pb-6 flex justify-between text-12' style={{ borderBottom: "1px solid #E8E8E8" }}>
            <div className=''>廠牌車款</div>
            <div className=''>獲讚數</div>
          </div>
          <div className='pt-16 text-14'>
            {hotMenuKindRank.map((item, index: number) => (
              <a
                href={`/buy-car/menu?brandId=${item.brandId}&kindId=${item.kindId}&sort=like&type=1`}
                className='flex justify-between cursor-pointer mb-18'
                key={index}
                target='_blank'
              >
                <div className='flex gap-4'>
                  <i
                    className='bg-cover no-repeat flex items-center justify-center w-16 h-16'
                    style={{ backgroundImage: `url(https://photo.8891.com.tw/2024/07/31/1722395371732616.png)` }}
                  >
                    {index + 1}
                  </i>
                  <div className='w-140 ellipsis'>
                    {item.brandName} {item.kindName}
                  </div>
                </div>
                <div className=''>{formatNumberWithCommas(item.total)}</div>
              </a>
            ))}
          </div>

          <div
            className='text-14 text-[#3264FF] w-130 h-30 bg-white rounded-4 font-semibold flex items-center justify-center mx-auto cursor-pointer'
            style={{ border: "1px solid #3264FF" }}
            onClick={() => {
              if (id) {
                window.open(`/buy-car/menu/share/form?id=${id}`);
              } else {
                window.open(`/buycar/postMenu?type=1`, "_blank");
              }
            }}
          >
            分享菜單
          </div>
        </div>
      )}
    </>
  );
};

// 待服務的前十廠牌
export const AwaitBrandServer: React.FC<{
  latest3MonthAgents: number;
  waitingServiceKindRank: IBuyCarMenuPolymer["waitingServiceKindRank"];
}> = ({ waitingServiceKindRank, latest3MonthAgents }) => {
  return (
    <>
      {waitingServiceKindRank?.length > 0 && (
        <div
          id={"AwaitBrandServerList"}
          className='w-240 rounded-4  px-10 mb-20 bg-white pb-16'
          style={{ border: "1px solid #E8E8E8" }}
        >
          <div className='text-center w-full text-18 mt-12 font-semibold my-14 pt-4'>待服務的前十廠牌</div>
          <div className='w-full pb-6 flex justify-between text-12' style={{ borderBottom: "1px solid #E8E8E8" }}>
            <div className=''>廠牌</div>
            <div className=''>待服務買家</div>
          </div>
          <div className='pt-16 text-14'>
            {waitingServiceKindRank.map((item, index: number) => (
              <a
                href={`/buy-car/menu?brandId=${item.brandId}`}
                target='_blank'
                className='flex justify-between cursor-pointer mb-18'
                key={index}
              >
                <div className='flex gap-4'>
                  <i
                    className='bg-cover no-repeat flex items-center justify-center w-16 h-16'
                    style={{ backgroundImage: `url(https://photo.8891.com.tw/2024/07/31/1722395371732616.png)` }}
                  >
                    {index + 1}
                  </i>
                  <div className='w-140 ellipsis'>{item.brandName}</div>
                </div>
                <div className=''>{formatNumberWithCommas(item.total)}</div>
              </a>
            ))}
          </div>

          <div
            className='text-14 text-[#3264FF] w-130 h-48 bg-white rounded-4 mt-4 font-semibold flex items-center justify-center mx-auto cursor-pointer flex-wrap'
            style={{ border: "1px solid #3264FF" }}
            onClick={() => {
              window.open(`/agent/investment`, "_blank");
            }}
          >
            搶先獲客
            <div className='text-12 text-center -mt-12' style={{ fontWeight: "400" }}>
              {latest3MonthAgents}位業代獲客中
            </div>
          </div>
        </div>
      )}
    </>
  );
};
